import { z } from 'zod';

import { defineStandalone } from '@apps/web/features/phoebe_chat_v3/registry/types';

const statusUpdatePayloadSchema = z
    .object({
        type: z.literal('status_update').optional(),
        label: z.string(),
        detail: z.string().nullable().optional(),
        phase: z.string().nullable().optional(),
        source: z.string().nullable().optional(),
        stage: z.string().nullable().optional(),
        tool_name: z.string().nullable().optional(),
        call_id: z.string().nullable().optional(),
    })
    .strip();

function MonitoringStoppedActivity() {
    return <span>Monitoring stopped</span>;
}

export const statusUpdateDefinitions = {
    status_update: defineStandalone('status_update', {
        disposition: 'render',
        schema: statusUpdatePayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
        group: null,
        render(payload) {
            if (payload.stage !== 'monitoring_stopped') {
                return null;
            }
            return <MonitoringStoppedActivity />;
        },
    }),
} as const;

export const statusUpdateContractFixtures = {
    valid: {
        type: 'status_update',
        label: 'Internal status label',
        detail: 'Internal status detail',
        phase: 'terminal',
        source: 'internal-monitor',
        stage: 'monitoring_stopped',
        tool_name: 'internal_tool_name',
        call_id: 'call-1',
    },
    malformed: {
        type: 'status_update',
        label: 7,
        detail: 'Internal status detail',
        stage: 'monitoring_stopped',
    },
} as const;
